import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let partnerVatsRestServiceConfig: IRestfulConfigMap = {
    "partnerVatsRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            getAll: {
                method: "get",
                path: "/api/partners/vats",
            },
            saveVats: {
                method: "put",
                path: "/api/partners/vats"
            },
            delete:{
                method: "delete",
                path: "api/partners/vats/:id",
                paramDefaults: { id: "@id" }
            },
            getCountries: {
                method: "get",
                path: "/api/partners/vats/countries"
            }
        }
    }
}

export { partnerVatsRestServiceConfig };
